import { Component, OnInit } from '@angular/core';
import { TitleInfo } from '@innovation-os-ng/ui/utils';
import { TranslateService } from '@itonics/ngx-translate-simple';
import { ConfirmOptions, ConfirmService } from '../service/confirm.service';

const DEFAULT_OPTIONS: ConfirmOptions = {
  closeable: true,
  dismissable: true,
  escapable: true,
  supportHTMLContent: false,
  customClass: 'confirm-modal'
};

@Component({
  selector: 'ui-confirm',
  templateUrl: './confirm.component.html',
  styleUrls: ['./confirm.component.scss']
})
export class ConfirmComponent implements OnInit {
  public uiAddTitleOptions: Array<TitleInfo> = [];
  public confirmOptions: ConfirmOptions = DEFAULT_OPTIONS;
  public selectedButton: number;

  constructor(public confirmService: ConfirmService, private translate: TranslateService) {}

  ngOnInit(): void {
    this.translate.get('ui-confirm.close').subscribe((title) => {
      this.uiAddTitleOptions = [{ selectorClass: 'nsm-dialog-btn-close', title }];
    });
    this.confirmService.onConfirmOptionsChanged.subscribe((options) => {
      this.confirmOptions = { ...this.confirmOptions, ...options };
    });
    this.confirmService.onButtonSelection.subscribe((buttonId) => {
      this.selectedButton = buttonId;
    });
  }
}
